import { Textarea } from "@arcadeai/design-system/components/ui/atoms/textarea";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { Control } from "react-hook-form";
import type { McpServerCreateRequest } from "../../types";

type InstructionsFormFieldProps = {
  control: Control<McpServerCreateRequest>;
  /** Hide the label/helper when the surrounding layout already provides them. */
  hideLabel?: boolean;
  hideDescription?: boolean;
};

export function InstructionsFormField({
  control,
  hideLabel,
  hideDescription,
}: InstructionsFormFieldProps) {
  return (
    <FormField
      control={control}
      name="instructions"
      render={({ field }) => (
        <FormItem>
          {hideLabel ? null : (
            <FormLabel>LLM instructions (optional)</FormLabel>
          )}
          <FormControl>
            <Textarea
              {...field}
              aria-label={hideLabel ? "LLM instructions" : undefined}
              placeholder="e.g. Always show drafts for me to review before sending. Keep replies concise and friendly."
              rows={4}
              value={field.value ?? ""}
            />
          </FormControl>
          {hideDescription ? null : (
            <FormDescription>
              Tell the LLM how it should use these tools.
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
